import { consume } from '@lit/context';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';

import {
  ConfiguratorContextType,
  GlobalComponentType,
  MobileContext,
  configuratorGlobal,
  global,
} from '@/context';
import { ANIMATION_SPEED, BREAKPOINT_MEDIUM_PX } from '@/settings';
import { buttonStyles } from '@/styles';
import { Step } from '@/types';

const DEFAULT_SUMMARY_TOP = 16;

/**
 * @element fg-configurator-action-sections
 */
@customElement('fg-configurator-action-sections')
export class FgConfiguratorActionSection extends LitElement {
  @property({ type: Number })
  currentStep = 0;

  @property({ type: Array })
  steps: Step[] = [];

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  @consume({ context: configuratorGlobal.context, subscribe: true })
  configuratorContext!: ConfiguratorContextType;

  @consume({ context: MobileContext, subscribe: true })
  isMobile: boolean = false;

  render() {
    const summaryTop = !this.configuratorContext.stickySummaryHeight
        ? DEFAULT_SUMMARY_TOP
        : this.configuratorContext.stickySummaryHeight + DEFAULT_SUMMARY_TOP,
      { layout } = this.globalContext;
    const mobileCollapsible =
      this.configuratorContext.mobileCollapsible !== '0';

    return html`
      <div
        class="action-sections
        ${classMap({
          'mobile-steps':
            (!mobileCollapsible && layout === 'retail') ||
            layout === 'wholesale',
        })}"
        style=${layout === 'wholesale' && !this.isMobile
          ? styleMap({ top: `${summaryTop}px` })
          : nothing}
      >
        <slot name="mobile-navigation"></slot>
        <section
          class="configurator-actions
          ${classMap({
            show:
              this.currentStep === this.steps.length ||
              this.globalContext.layout === 'wholesale' ||
              mobileCollapsible,
            hidden:
              this.currentStep !== this.steps.length &&
              this.globalContext.layout !== 'wholesale',
          })}
          "
        >
          <slot name="configurator-actions"></slot>
        </section>
      </div>
    `;
  }

  static styles = [
    buttonStyles,
    css`
      @media screen and (max-width: ${BREAKPOINT_MEDIUM_PX - 1}px) {
        .action-sections.mobile-steps {
          position: absolute;
          box-sizing: border-box;
          bottom: 0;
          left: 0;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          column-gap: 16px;
          width: 100%;
          box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
        }

        :host([part='wholesale']) .action-sections.mobile-steps {
          flex-direction: column-reverse;
        }

        .configurator-actions {
          width: 100%;
          max-height: 0;
          opacity: 0;
          transition:
            max-height ${ANIMATION_SPEED}s ease-in-out,
            opacity ${ANIMATION_SPEED}s ease-in-out;
          height: auto;
        }

        .configurator-actions.show {
          opacity: 1;
          max-height: 100vh;
        }
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        :host {
          position: relative;
        }

        .action-sections {
          position: sticky;
        }
      }
    `,
  ];
}
